var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataContainer"},[_c('div',{staticClass:"data-content"},[_c('div'),_c('router-link',{attrs:{"to":{ name: 'dataView', query: {
      id: _vm.data.url
    } }}},[_c('h4',[_vm._v(_vm._s(_vm.data.title))])])],1),_c('ul',{staticClass:"data-control"},[_c('li',[_c('i',{staticClass:"el-icon-download"}),_vm._v(" "+_vm._s(_vm.data.size)+"(MB) ")]),_c('li',[_c('i',{staticClass:"el-icon-time"}),_vm._v(" "+_vm._s(_vm.data.uptime)+" ")]),_c('li',[_c('router-link',{attrs:{"to":{ name: 'dataView', query: {
        id: _vm.data.url
      } }}},[_c('i',{staticClass:"el-icon-view"}),_vm._v(" 查看 ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }